import __vue_component__ from './Icons/Online.vue.js';
import __vue_component__$2 from './Icons/Offline.vue.js';
import __vue_component__$1 from './Icons/Busy.vue.js';
import __vue_component__$3 from './Icons/Focus.vue.js';
import __vue_component__$4 from './Icons/Approved.vue.js';
import __vue_component__$5 from './Icons/Declined.vue.js';

//
var script = {
  name: 'Avatar',
  components: {
    Online: __vue_component__,
    Busy: __vue_component__$1,
    Offline: __vue_component__$2,
    Focus: __vue_component__$3,
    Approved: __vue_component__$4,
    Declined: __vue_component__$5
  },
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    presence: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 0
    },
    tag: {
      type: String,
      default: 'div'
    },
    link: {
      type: String,
      default: '#'
    },
    outline: {
      type: String,
      default: '#fff'
    },
    status: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      error: false
    };
  },

  computed: {
    style() {
      return {
        'background-color': this.outline
      };
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Avatar/Avatar.vue_rollup-plugin-vue=script.js